import { render, staticRenderFns } from "./ScorView.vue?vue&type=template&id=5a09e836&scoped=true"
import script from "./ScorView.vue?vue&type=script&lang=js"
export * from "./ScorView.vue?vue&type=script&lang=js"
import style0 from "./ScorView.vue?vue&type=style&index=0&id=5a09e836&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a09e836",
  null
  
)

export default component.exports